import { cn } from "@/lib/utils";
import { useLocation } from "react-router-dom";
import { Breadcrumb } from "./Breadcrumb";
import { ToolActions, TranscriptButton } from "./ToolActions";

interface SecondaryHeaderProps {
  className?: string;
}

export function SecondaryHeader({ className }: SecondaryHeaderProps) {
  const location = useLocation();
  const toolPath = location.pathname.split("/")[1];

  // Check if the current page is a tool page
  const isToolPage = ["cvr", "evm", "target-cost", "whatsapp-analyzer", "fatigue-management"].includes(toolPath);

  if (!isToolPage) return null;

  return (
    <nav
      aria-label="Tool navigation"
      className={cn(
        "sticky top-14 z-40 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60",
        className
      )}
    >
      <div className="container max-w-screen-2xl mx-auto px-4">
        <div className="flex h-10 items-center justify-between">
          <Breadcrumb />
          <div className="flex items-center gap-2">
            {toolPath === 'whatsapp-analyzer' && <TranscriptButton />}
            <ToolActions toolType={toolPath} />
          </div>
        </div>
      </div>
    </nav>
  );
}
